const _ = require('lodash')
const isSiteHistoryEndpoint = (rawUrl, isPreview) => isPreview && _.startsWith(rawUrl, 'https://editor.wix.com/html/editor/web/renderer/revisions/view')

module.exports = {
    getExternalBaseUrl: (rawUrl, warmupUtils, isPreview = false) => {
        const relevantPathParts = isSiteHistoryEndpoint(rawUrl, isPreview) ? 8 : 7
        return warmupUtils.urlUtils.getBaseUrlWithPath(warmupUtils.urlUtils.parseUrl(rawUrl), relevantPathParts)
    }
}
